var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import Button from 'nucleus-widgets/lib/Button/Button';
import ButtonStyles from 'nucleus-widgets/lib/Button/Button.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { omit } from 'lodash';
var Classes = __assign(__assign({}, ButtonStyles), { button: __assign({}, ButtonStyles) });
function getOptionalValue(value, defaultValue) {
    return value === null || typeof value === 'undefined' ? defaultValue : value;
}
/**
 * The event ContactPlanner widget.
 */
var ContactPlannerWidget = /** @class */ (function (_super) {
    __extends(ContactPlannerWidget, _super);
    function ContactPlannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.onButtonClick = _this.onButtonClick.bind(_this);
        return _this;
    }
    ContactPlannerWidget.getConfig = function (state, rawConfig, type, widgetId) {
        /*
         * Overriding BaseWidget.getConfig() was necessary
         *in order to pull most of the shared props from state.
         */
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'getConfig' does not exist on type 'typeo... Remove this comment to see the full error message
        var mappedConfig = _super.getConfig.call(this, state, rawConfig, type, widgetId);
        var _a = state.event.planner, firstName = _a.firstName, lastName = _a.lastName, company = _a.company;
        mappedConfig.shared = __assign(__assign({}, mappedConfig.shared), { firstName: getOptionalValue(mappedConfig.shared.firstName, firstName), lastName: getOptionalValue(mappedConfig.shared.lastName, lastName), company: getOptionalValue(mappedConfig.shared.company, company) });
        return mappedConfig;
    };
    ContactPlannerWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { button: {
                button: omit(this.getElementInlineStyle('button'), 'textAlign')
            }, buttonWrapper: { textAlign: this.getElementText('button').textAlign }, text: this.getElementInlineStyle('text'), contactUsModalStyles: {
                modalPlannerNameStyles: this.getElementInlineStyle('contactUsModalStyles.modalPlannerNameStyles'),
                modalFieldStyles: this.getElementInlineStyle('contactUsModalStyles.modalFieldStyles'),
                modalLabelStyles: this.getElementInlineStyle('contactUsModalStyles.modalLabelStyles'),
                modalSendButtonStyles: this.getElementInlineStyle('contactUsModalStyles.modalSendButtonStyles')
            } });
    };
    ContactPlannerWidget.prototype.onButtonClick = function () {
        if (this.props.onClick) {
            var _a = this.props.config, shared = _a.shared, appData = _a.appData, buttonText = _a.buttonText;
            var _b = this.props, isPreview = _b.isPreview, translate = _b.translate;
            this.props.onClick(buttonText, {
                firstName: translate(shared.firstName),
                lastName: translate(shared.lastName),
                phoneNumber: translate(shared.phoneNumber),
                company: translate(shared.company),
                displayEmail: appData.displayEmail,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                emailAddress: appData.email && appData.email.emailAddress
            }, this.getStyleObject(), isPreview);
        }
    };
    ContactPlannerWidget.prototype.render = function () {
        var _a = this.props, config = _a.config, classes = _a.classes, translate = _a.translate;
        /*
         * Originally, buttons were implemented with rich text editors, but since then
         * they have been updated to be normal textboxes. So we have to allow the text
         * property to come in as rich text or normal plain text. https://jira/browse/FLEX-6581
         */
        var isRichText = false;
        var text = config.buttonText;
        // eslint-disable-next-line no-prototype-builtins
        if (config.buttonText.hasOwnProperty('htmlContent')) {
            isRichText = true;
            text = config.buttonText.htmlContent;
        }
        return (React.createElement(Button, __assign({}, resolveTestId(this.props), { classes: classes, style: this.getStyleObject(), text: translate(text), onClick: this.onButtonClick, isRichText: isRichText })));
    };
    ContactPlannerWidget.displayName = 'ContactPlannerWidget';
    ContactPlannerWidget.propTypes = {
        config: PropTypes.shape({
            shared: PropTypes.shape({
                firstName: PropTypes.string,
                lastName: PropTypes.string,
                email: PropTypes.object,
                displayEmail: PropTypes.bool,
                company: PropTypes.string,
                phoneNumber: PropTypes.string
            })
        }),
        classes: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func.isRequired
    };
    ContactPlannerWidget.defaultProps = {
        classes: Classes
    };
    return ContactPlannerWidget;
}(BaseWidget));
export default ContactPlannerWidget;
